import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorIcon from './parts/error-icon.js';
import InfoIcon from './parts/info-icon.js';
import WarningIcon from './parts/warning-icon.js';
import { cn } from '../../utils/classnames.js';
import Button from '../button/index.js';
import Icon from '../icon/index.js';
import Text from '../text/index.js';
const ICONS = {
    info: InfoIcon,
    warning: WarningIcon,
    error: ErrorIcon,
};
function Callout({ children, type = 'info', action, className, left, onClose, }) {
    const CalloutIcon = ICONS[type];
    return (_jsx("div", { className: cn(className, 'ui-relative ui-flex ui-w-full ui-rounded-[12px] ui-p-px', type === 'info' &&
            'ui-bg-gradient-to-b ui-from-gray-200/38 ui-to-gray-400/28 theme-dark:ui-from-[#37373b] theme-dark:ui-to-[#303033]', type === 'warning' &&
            'ui-bg-gradient-to-tr ui-from-[#f7aa37]/40 ui-to-[#f7aa37]/8', type === 'error' &&
            'ui-bg-gradient-to-tr ui-from-[#f76331]/40 ui-to-[#f76331]/8'), children: _jsxs("div", { className: cn('ui-flex ui-size-full ui-items-start ui-gap-2 ui-rounded-[11px] ui-bg-gray-100 ui-p-3 theme-dark:ui-bg-neutral-700', type === 'warning' &&
                'ui-bg-gradient-to-r ui-from-[#f7aa37]/15 ui-to-15%', type === 'error' &&
                'ui-bg-gradient-to-r ui-from-[#f76331]/15 ui-to-15%'), children: [left ?? _jsx(CalloutIcon, {}), _jsx(Text, { className: "ui-flex-1 ui-self-center ui-text-gray-600 theme-dark:!ui-text-neutral-200", size: 12, as: "div", children: children }), action && (_jsx(Button, { size: "small", dataTestId: "callout-action-button", 
                    // eslint-disable-next-line react/jsx-handler-names
                    onClick: action.onClick, children: action.label })), onClose && (_jsx("button", { onClick: onClose, type: "button", className: "ui-absolute ui-right-2 ui-top-2", "data-testid": "close-callout-button", children: _jsx(Icon, { name: "x-mark", size: 16, className: "theme-dark:text-white" }) }))] }) }));
}
export default Callout;
